/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const AcquisitionClickParam = {
    gclid: 'gclid',
    gbraid: 'gbraid',
    wbraid: 'wbraid',
    fbclid: 'fbclid',
    ttclid: 'ttclid',
    twclid: 'twclid'
} as const;
export type AcquisitionClickParam = typeof AcquisitionClickParam[keyof typeof AcquisitionClickParam];


export function instanceOfAcquisitionClickParam(value: any): boolean {
    for (const key in AcquisitionClickParam) {
        if (Object.prototype.hasOwnProperty.call(AcquisitionClickParam, key)) {
            if (AcquisitionClickParam[key as keyof typeof AcquisitionClickParam] === value) {
                return true;
            }
        }
    }
    return false;
}

export function AcquisitionClickParamFromJSON(json: any): AcquisitionClickParam {
    return AcquisitionClickParamFromJSONTyped(json, false);
}

export function AcquisitionClickParamFromJSONTyped(json: any, ignoreDiscriminator: boolean): AcquisitionClickParam {
    return json as AcquisitionClickParam;
}

export function AcquisitionClickParamToJSON(value?: AcquisitionClickParam | null): any {
    return value as any;
}

export function AcquisitionClickParamToJSONTyped(value: any, ignoreDiscriminator: boolean): AcquisitionClickParam {
    return value as AcquisitionClickParam;
}

